<template lang="html">
  <div id="page-container"
       class="sidebar-o enable-page-overlay side-scroll page-header-fixed page-header-dark main-content-narrow">
    <the-aside/>
    <sidebar/>
    <the-header/>
    <!-- Main Container -->
    <main id="main-container">
      <router-view/>
    </main>
    <!-- END Main Container -->
    <the-footer/>
  </div>
</template>

<script>
  import Dashmix from '@/assets/dashmix/js/main/app'
  import TheFooter from '@/components/main-layout/Footer'
  import TheAside from '@/components/main-layout/Aside'
  import TheHeader from '@/components/main-layout/Header'
  import Sidebar from '@/components/main-layout/Sidebar'

  import '@/assets/dashmix/plugins/bootstrap-notify/bootstrap-notify.min.js'
  import '@/assets/dashmix/plugins/jquery-sparkline/jquery.sparkline.min.js'
  import '@/assets/dashmix/plugins/bootstrap-datepicker/js/bootstrap-datepicker.min.js'
  import '@/assets/dashmix/plugins/bootstrap-datepicker/css/bootstrap-datepicker.min.css'

  export default {
    components: {
      TheAside,
      TheHeader,
      Sidebar,
      TheFooter
    },
    created() {
      // load javascript dashmix theme
      const dashmix = new Dashmix()
      window.dashmix = dashmix
    },
    mounted() {
      window.dashmix.init()
      window.dashmix.helpers('datepicker')
    }
  }
</script>

<style lang="css">
</style>
